<template>
<div>
  <Head :leftarrow="true" :lroute="backs" v-show="!this.noheader"></Head>
  <div class="me-center" v-if="info"  :class="this.noheader ? 'noheader': ''">
    <div style="background-color: #fff;">
      <van-row type="flex" align="center"  class="o-divx">
        <van-col span="20">
          <p class="op1">{{info.title}}</p>
          <p class="op2">{{info.showtime}}</p>
          <p class="op2">{{info.moviename}}</p>
          <p class="op2">{{info.lg}} {{info.hallname}} {{info.zuo}}</p>
          <p class="op2">购票数量 X {{zuo_num}}张</p>
        </van-col>
        <van-col span="4">
          <p class="opc"></p>
        </van-col>
      </van-row>
      <div class="order-price">
        <span class="title">票价总计</span>
        <span class="price">{{info.realprice}}元</span>
      </div>  
      <div class="ticket-info">
          <div class="tip"><span>请到影院内任意取票机取票</span></div>
          <div class="code">
            <p  v-if="info.printcode">
                <label>取票号</label><strong>{{info.printcode}}</strong>
            </p>
            <p  v-if="info.printcode1">
                <label>验证码</label><strong>{{info.printcode1}}</strong>
            </p>
          </div>
            <div class="print_qrcode">
                <img :src="print_qrcode_url" @load="onQrcodeLoaded"/>
            </div>
            <div class="qrcode_save" style="display:none">
                <van-icon name="photo-o" />
                <a href="javascript:;" id="downloadBlobUrl" >保存到相册</a>
           </div>
           <div class="static_icon" v-show="show_tp_icon"><img :src="icon_tp" /></div>
           <div class="static_icon" v-show="show_ok_icon"><img :src="icon_ok" /></div>
      </div>
      <div class="order-handle">
            <div class="info">
                <p>订单号: {{ordercode}}</p>
            </div>

            <van-button plain v-show="!info.usekeys && info.tp" @click.native="tp" type="danger" size="small" class="btn">申请 退票</van-button>
            <van-button plain v-show="!info.usekeys && !info.tp" type="danger" size="small" class="btn disabled">申请 退票</van-button>
     </div>
	 <div class="cgkey-top" v-show="info.usekeys == 1 && info.tp"><p>此订单使用了兑换券不允许退票</p></div>
    </div>
  </div>
  <Foot></Foot>
</div>
</template>
<style>
  .me-center-nofoot.noheader{
      padding:0;
  }
  .o-divx{
    background-image: linear-gradient(to right , #f4d7d6, #edc4d3);
    padding: 10px 20px;
    margin: 20px;
    border-radius: 13px;
  }
  .o-divx .op1{
    margin: 0px 0px 10px 0px;
    font-size: 18px;
    color: #323233;
  }
  .o-divx .op2{
    margin-top: 0px;
    margin-bottom:5px;
    font-size: 12px;
    color: #323233;
  }
  .opc{
    font-size: 14px;
    color: white;
    text-align: right;
  }
  .oxz p{
    font-size: 12px;
    margin-top: 0px;
    margin-bottom: 0px;
    color: #7D7E80;
  }
  .bold{
    font-weight: bold;
  }

  body{
      background:#fff;
  }
  .ticket-info{
position: relative;
padding-top:45px;
  }

  .ticket-info .tip{

      margin:0 auto;
    position: absolute;
    top: 10px;
    left: 50%;
    margin-left: -160px;
    /* 左外边距宽度的一半，50% */
    text-align: center;
  }

.ticket-info .tip span{
    font-size:12px;
    color:#7d8dae;
    width:320px;
    display:block;
}
.ticket-info .tip span:before {
    display: inline-block;
    position: relative;
    top: -4px;
    right: 5px;
    content: "";
    width: 20%;
    height: 0px;
    border: 1px dashed #7d8dae;
}
.ticket-info .tip span:after {
    display: inline-block;
    position: relative;
    top: -4px;
    left: 5px;
    content: "";
    width: 20%;
    height: 0px;
    border: 1px dashed #7d8dae;
}

  .ticket-info .code{
      width:60%;
      margin:0 auto;
      background:#f8f8f8;

  }
  .ticket-info .code label{
    color: #999;
    font-size: 12px;
    margin-right: 15px;
  }
   .ticket-info .code p{
    margin: 0;
    padding: 5px 10px;
  }

  .ticket-info .print_qrcode{
      text-align: center;
   }

  .ticket-info .static_icon{
      position: absolute;
      width:100px;
      height:100px;

        top:20px;
        right:20px
  }

  .ticket-info .static_icon img{
      width:100%;
      height:100%;
  }

  .qrcode_save{
      clear:both;
      height:30px;
      width:100px;
      margin:0 auto;
  }

  .qrcode_save i{
       float:left;
       margin-right:5px
  }

  .qrcode_save a{
      float:left;
          font-size: 12px;
    color: #666;
    text-decoration: underline;
  }

.order-handle{
    margin:0 auto;
    display: flex;
    justify-content: space-between;
          border-top:1px solid #ebedf0;
      width:80%;
      align-items: center;
}
.order-handle .info{
    padding-top:10px;

}

.order-handle .info p{
       line-height:23px;
       padding:0;margin:0;
       font-size: 12px;
}


  .order-handle .btn{
      margin-top:15px;
  }

  .order-handle .btn.disabled{
     border:1px solid #ddd;
     color:#ddd;

  }
  
  .cgkey-top{
	line-height:23px;
	width:80%;
	color:red; 
	font-size:12px;
	margin: 0 auto;
  }

  .order-price{
    display: flex;
    padding: 10px 15px;
    font-size: 12px;
    color: #fff;
    background-image: linear-gradient(to right , #d76f6b, #c02b61);
    border-radius:5px;
    width: 72%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    line-height: 26px;
  }

  .order-price .title{
    font-size: 16px;
  }

  .order-price .price{
    font-size: 20px;
  }

</style>
<script>
  import Head from '@/components/Head.vue'
  import Foot from '@/components/Foot.vue'
  import html2canvas from 'html2canvas';
	import http from '../http.js';
	import { Toast,Dialog } from 'vant';

  export default {
	metaInfo: {
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0, viewport-fit=cover' }
      ]
    },
    data(){
      return{
        info:[],
        ordercode:'',
        status:'',
        routeflag:false,
        api:'',
        print_qrcode_url:'',
        show_tp_icon:false,
        show_ok_icon:false,
        icon_tp: require('../static/icon_tp.png'),
        icon_ok: require('../static/icon_ok.png'),
		    noheader: 0,
        zuo_num:0
      }
    },
    components: {
      Head,
      Foot
    },
    beforeCreate () {
       // http.check()
    },
    created(){
        this.init();
    },
    mounted() {

	},

    methods:{

      init(){
          this.checkLogin().then(()=>{
            this.ordercode=this.$route.query.ordercode
            this.noheader=this.$route.query.noheader
            this.status=this.$route.params.status
            this.$c.log(this.status)
            this.getdetail()
          })
      },
      async checkLogin(){
          return await http.check();
      },
      getdetail(){
        //let ordercode=this.$route.params.ordercode
        let ordercode=this.ordercode
        this.$http.post(this.$burl+'&c=movie&m=orderdetail',{ordercode:ordercode}).then(res=>{

            this.info=res.data
            let zuos = this.info.zuo.split(",");
		        this.zuo_num = zuos.length;
            this.show_ok_icon = res.data.state == 2
            this.show_tp_icon = res.data.state == 3
            this.api=res.data.api
            this.print_qrcode_url=this.$burl+'&c=movient&m=orderqrcode&api='+res.data.api+'&order='+ordercode+'&print_code='+res.data.print_code
        }).catch(()=>{})
      },
      onQrcodeLoaded(){

            html2canvas(document.querySelector('#app')).then(canvas => { 
                let saveUrl = canvas.toDataURL('image/png');
                let blob = this.base64ToBlob(saveUrl);
                let URL = window.URL|window.webkitURL;

                const downloadDataUrlDom = document.getElementById('downloadBlobUrl');
                downloadDataUrlDom.setAttribute('href', window.URL.createObjectURL(blob));
                downloadDataUrlDom.setAttribute('download', this.info.title);
            });
        },
      backs(){
        this.$router.go(-1)
        return true;
      },
      cp(e){
        if(e=='1'){
          return '待取票'
        }else if(e=='2'){
          return '已取票'
        }else if(e=='3'){
          return '已退票'
        }else{
          return '未知状态'
        }
      },
      tp(){
		let obj = this;
        this.$dialog.confirm({
          title: '提示',
          message: '退款之后将会收取'+this.info.tkprice+'元/张的手续费，确认退款？'
        }).then(() => {
          this.$http.post(this.$burl+'&c=movie&m=tp',{ordercode:this.ordercode,t1:this.info.t1,t2:this.info.t2})
          .then((res)=>{
              Dialog.alert({
                message: res.message
              }).then(() => {
                console.log(res.message);
                this.$router.replace({path: 'orderdetail',
                query: {
                  ordercode:obj.ordercode
                }})
                this.$router.go(-1)
              });

          }).catch((res)=>{
            console.log(res);
          })
        }).catch(() => {
          // on cancel
        });
        
      },
        base64ToBlob (code) {
            let parts = code.split(';base64,')
            let contentType = parts[0].split(':')[1]
            let raw = window.atob(parts[1])
            let rawLength = raw.length
            let uInt8Array = new Uint8Array(rawLength)
            for (let i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i)
            }
            return new Blob([uInt8Array], {type: contentType})
        },

        dataURLToBlob(dataurl) {
          var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          return new Blob([u8arr], {type: mime})
        },

    },
    computed:{
 
    },
    /*
    beforeRouteLeave (to, from , next) {
      if(this.routeflag){
        next()
      }else{
        this.routeflag=true
        this.$c.log('aa')
        next({
          name: 'orderlist',
          params: {
            status:this.status
          },
          replace:true
        })
      }
      
    }
    */
  }
</script>

<style >
  
  
</style>